import React from 'react';
import { Navbar, Nav, Container, Form } from 'react-bootstrap'
import SelectorLanguage from 'components/common/Selector_Language';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import SelectorRecords from 'pages/Records';
import Label from 'components/general/Label';
import { useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import { useLocation, useMatch, Link, useResolvedPath, useParams } from 'react-router-dom';
import { getURL } from 'helpers/utils';
import SelectorNoc from 'components/common/selectors/selector-noc';
import Records from 'pages/Records';


//Main Menu
const ElementsNavBar = () => {
    const location = useLocation();
    let pathUrl = location.pathname;
    //let isDisciplines = useMatch({ path: "/:mirs_competition/:mirs_language/disciplines/*" }, pathUrl);
    let params = useParams();
    //const sw = (pathUrl !== '/' && !hasDisciplines)
    params.mirs_rsc = params.mirs_rsc || params.mirs_event_rsc


    let paramsRecords = { ...params };
    paramsRecords["mirs_discipline"] = "";
    //let paramsAthletes = { ...params };

    //Copy object in order to change 
    let paramsURL = { ...params };

    paramsURL["mirs_date"] = "";
    paramsURL["mirs_discipline"] = "";
    paramsURL["mirs_event"] = "";
    paramsURL["mirs_noc"] = "";
    paramsURL["mirs_medal"] = "";



    //Change object if make changes over params make changes in componets related   (Change URL object)
    let urlAthletes = useGetURL(paramsURL, 'athletes')
    let urlCompetitionSchedule = useGetURL(paramsURL, 'competitionschedule')
    let urlMedal = useGetURL(paramsURL, 'medal')
    let urlRecords = useGetURL(paramsRecords, 'records')

    return (
        <>
            <Nav.Link as={CustomLink} to={urlCompetitionSchedule}><Label data={'MenuSchedules'} /></Nav.Link>
            <Nav.Link as={CustomLink} to={urlAthletes}><Label data={'LabelAthletes'} /></Nav.Link>
            <SelectorDiscipline page="schedule" />
            <Nav.Link as={CustomLink} to={urlRecords}><Label data={'LabelRecords'} /></Nav.Link>
            <Nav.Link as={CustomLink} to={urlMedal}><Label data={'LabelMedals'} /></Nav.Link>
        </>
    )
}


//HOC (Higth Order Component) component Link in order to style selected 
function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    //let match = useMatch({ path: resolved.pathname, end: true });
    return (
        <div className="nav-schedule" >
            <Link
                to={to}
                {...props}
            >
                {children}
            </Link>
            {/* {match && " (active)"}*/}
        </div>
    );
}

export function HeaderDefault() {
    const location = useLocation();
    return (
        <Navbar expand="lg" sticky="top" id="mirs-first-navigation-bar">
            <Container>
                <Navbar.Brand href="#schedule" className="d-flex">
                    <div className="PG2024-brand">M.I.R.S. Application</div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbar-main" />
                <Navbar.Collapse id="navbar-main">
                    <Nav activeKey={""} active={location.pathname} className="ms-auto mb-2 mb-lg-0">
                        <ElementsNavBar />
                    </Nav>
                    <Form  >
                        <SelectorLanguage />
                    </Form>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
};
export default HeaderDefault